<template>
  <b-card no-body>
    <b-card-header header-tag="header">
      <div>
        <span class="header-txt">{{ collapseHeader }}</span>
        <button v-if="showBtnClear" class="btn-clear" @click="clear">
          Clear
        </button>
        <div block v-b-toggle="collapseId">
          <img
            v-if="visible"
            class="expand-icon"
            src="@/assets/icon/collapse-expand-icon.svg"
          />
          <img
            v-if="!visible"
            class="collapse-icon"
            src="@/assets/icon/collapse-hide-icon.svg"
          />
        </div>
      </div>
    </b-card-header>
    <b-collapse :id="collapseId" v-model="visible">
      <b-card-body>
        <slot>
          {{ defaultText }}
        </slot>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      defaultText: `Collapse Information`,
      visible: true
    };
  },
  props: ['collapseId', 'collapseHeader', 'showBtnClear'],
  methods: {
    clear() {
      this.$emit('clear');
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-clear {
  position: absolute;
  right: 45px;
  border: 1px solid;
  font-size: 12px;
  border-radius: 5px;
  padding: 3px;
  background: #ffffff;
  border: 1px solid #5b6ef5;
  color: #5b6ef5;
}
.card-header {
  background-color: #fff;
  border-bottom: none;
  font-family: Inter;
  font-weight: 600;
  font-size: 20px;
  color: #203a54;
  padding: 18px 20px;
  border-bottom: 1px solid #f3f5fa;

  & > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.collapsed {
      .expand-icon {
        display: block;
      }
      .collapse-icon {
        display: none;
      }
    }
    &.not-collapsed {
      .expand-icon {
        display: none;
      }
      .collapse-icon {
        display: block;
      }
    }
  }
}
.card {
  background-color: #f6f8fc;
}
.header-txt {
  text-transform: capitalize;
}
</style>
